import { j as f } from "../../../node_modules/react/jsx-runtime.js";
import { memo as c } from "react";
import x from "../../atoms/Button/Button.js";
const B = c(
  ({
    total_pages: o,
    currentPage: i,
    onJump: n,
    activePage: l,
    paginationStyles: S,
    disabled: u
  }) => {
    const s = [], h = [
      /* @__PURE__ */ f.jsx(
        x,
        {
          className: S.middle,
          color: "neutral",
          variant: "ghost",
          label: "...",
          disabled: u
        },
        "middle1"
      ),
      /* @__PURE__ */ f.jsx(
        x,
        {
          className: S.middle,
          color: "neutral",
          variant: "ghost",
          label: "...",
          disabled: u
        },
        "middle2"
      )
    ], t = (r, m) => /* @__PURE__ */ f.jsx(
      x,
      {
        className: l == null ? void 0 : l(m),
        color: "neutral",
        variant: "ghost",
        label: r,
        onClick: () => n == null ? void 0 : n(m),
        disabled: u
      },
      m
    );
    if (o <= 7)
      for (let r = 1; r <= o; r++)
        s.push(t(r.toString(), r));
    else if (i <= 4) {
      for (let r = 1; r <= 5; r++)
        s.push(t(r.toString(), r));
      s.push(h[0]), s.push(t(o.toString(), o));
    } else if (i >= o - 3) {
      s.push(t("1", 1)), s.push(h[0]);
      for (let r = o - 4; r <= o; r++)
        s.push(t(r.toString(), r));
    } else {
      s.push(t("1", 1)), s.push(h[0]);
      for (let r = i - 1; r <= i + 1; r++)
        s.push(t(r.toString(), r));
      s.push(h[1]), s.push(t(o.toString(), o));
    }
    return s;
  }
);
export {
  B as RenderButtons
};
//# sourceMappingURL=RenderButtons.js.map
